import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';
import ScreenRotation from '@mui/icons-material/ScreenRotationOutlined';
import { alpha } from '@mui/material/styles';

import { createSx } from '../../utils';
import { TOUCH_DEVICE_MEDIA_QUERY } from '../../hooks/useIsTouchDevice';

const sx = createSx({
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: (theme) => alpha(theme.palette.common.black, 0.5),
    zIndex: 1500,
  },
  icon: {
    backgroundColor: 'info.main',
    borderRadius: '50%',
    padding: 2,
  },
});

const isMobileLanscape = () =>
  screen.height < 700 &&
  screen.orientation?.type.startsWith('landscape') &&
  matchMedia(TOUCH_DEVICE_MEDIA_QUERY).matches;

const PortraitOrientationLock = () => {
  const [showWarning, setShowWarning] = useState(isMobileLanscape);
  const { t } = useTranslation();
  useEffect(() => {
    const handleResize = () => {
      setShowWarning(isMobileLanscape());
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (showWarning) {
    return (
      <Stack
        spacing={2}
        sx={sx.container}
      >
        <Box sx={sx.icon}>
          <ScreenRotation fontSize='large' />
        </Box>
        <Typography variant='body2' color='common.white'>
          {t('rotateDeviceWarning')}
        </Typography>
      </Stack>
    );
  }
  return null;
};
export default PortraitOrientationLock;
